import React, { useMemo } from 'react';
import { openInBrowser } from '@/utils/bridge';
import { jumpToPageByH5 } from '@/utils/fn';
import { reportClick } from '@/utils/report';
import { CHART_INFO, OPTIMIZE_INFO } from '../config';
import styles from '../index.less';

const handleAnchorClick = (e, info = {}, type) => {
  e.preventDefault();
  if (info?.to === 'chart') {
    reportClick({
      page_name: 'intime_monitor_detail',
      button_name: 'to_chart',
      type,
    });
    jumpToPageByH5(info.link);
  } else {
    reportClick({
      page_name: 'intime_monitor_detail',
      button_name: 'to_optimize',
      type,
    });
    openInBrowser({ url: info.link });
  }
};

const IndicatorTip = ({ type, level, status = 0, poorLineNum, sn }) => {
  const optimizeInfo = useMemo(() => {
    let tipInfo = type === 'disk' ? OPTIMIZE_INFO['disk'][status] : OPTIMIZE_INFO[type][level];
    if (poorLineNum > 0) {
      tipInfo = {
        suggest: `您有${poorLineNum}条线路${CHART_INFO[type].lineIndicatorName}影响收益，请及时调整；`,
        linkText: '查看详情',
        link: `/monitor/chart/${sn}?indicator=${type}`,
        to: 'chart',
      };
    }
    return tipInfo;
  }, [type, status, level, poorLineNum, sn]);

  return (
    <div className={`${styles['indicator-tip']} ${styles[`level-${level}`]}`}>
      <i className={styles['indicator-tip-icon']} />
      <p>
        {optimizeInfo?.suggest}
        {optimizeInfo?.linkText && (
          <a href="/#" onClick={e => handleAnchorClick(e, optimizeInfo, type)}>
            {optimizeInfo.linkText}
          </a>
        )}
      </p>
    </div>
  );
};

export default IndicatorTip;
